"use strict";

import './css_load';
import '@splidejs/splide/src/css/template/default/index.scss';
import "../scss/style.scss";
import './firstview/_index';
import './calculateScroll/_index'
import './space/_index';
import './scrollAnimation/_index';
import './map/_index';
import './scrollTop/_index';
import './accordion/_index';
import './splide/_index';
import './headerMenu/_index';
import './firstAnimation/_index';
import './gsap/_index';
import './clipboard/_index';
// import './fetch/_index';
// import './modal/_index';

window.addEventListener('load', () => {
  const section = document.getElementsByClassName('l-section__main')[0];
  section.style.opacity = 1;
})

// import './css_load';